import {
  checkTokenExpired,
  chooseTeam,
  getDepartments,
  getTeams,
  getUser,
  login,
  resendVerifyEmail,
  sendForgetPasswordLink,
  setPassword,
  updateUser,
  registerLineNotify,
  unregisterLineNotify,
} from '@/api/user';

import {
  CHECK_TOKEN_EXPIRED,
  CHECKING_TOKEN_EXPIRED,
  CHOOSE_TEAM,
  CHOOSING_TEAMS,
  GET_DEPARTMENTS_DONE,
  GET_DEPARTMENTS,
  GET_TEAMS_DONE,
  GET_TEAMS,
  GET_USER_DONE,
  GET_USER,
  GETTING_DEPARTMENTS,
  GETTING_TEAMS,
  GETTING_USER,
  RESEND_VERIFY_EMAIL,
  RESENDING_VERIFY_EMAIL,
  SEND_FORGET_PASSWORD_LINK,
  SENDING_FORGET_PASSWORD_LINK,
  SET_LOGIN_DATUM_DONE,
  SET_LOGIN_DATUM,
  SET_PASSWORD,
  SETTING_PASSWORD,
  UPDATE_USER,
  UPDATING_USER,
  USER_LOGGING,
  USER_LOGIN,
  REGISTER_LINE_NOTIFY,
  UNREGISTER_LINE_NOTIFY,
} from './constants';

export default {
  async [CHECK_TOKEN_EXPIRED]({ commit }, token) {
    commit(CHECKING_TOKEN_EXPIRED, true);
    try {
      const res = await checkTokenExpired(token);
      commit(CHECKING_TOKEN_EXPIRED, false);
      return Promise.resolve(res);
    } catch (error) {
      commit(CHECKING_TOKEN_EXPIRED, false);
      return Promise.reject(error);
    }
  },
  async [CHOOSE_TEAM]({ commit, dispatch, state }, tid) {
    commit(CHOOSING_TEAMS, true);
    try {
      const { team_identification: id, team_name: name, token } = await chooseTeam(tid);
      dispatch(SET_LOGIN_DATUM, { id, name, token });
      commit(CHOOSING_TEAMS, false);
      return Promise.resolve();
    } catch (error) {
      dispatch(SET_LOGIN_DATUM, {
        token: state.token,
      });
      commit(CHOOSING_TEAMS, false);
      return Promise.reject(error);
    }
  },
  async [GET_DEPARTMENTS]({ commit }) {
    commit(GETTING_DEPARTMENTS, true);
    try {
      const { departments = [] } = await getDepartments();
      commit(GET_DEPARTMENTS_DONE, departments);
      commit(GETTING_DEPARTMENTS, false);
      return Promise.resolve();
    } catch (error) {
      commit(GET_DEPARTMENTS_DONE, []);
      commit(GETTING_DEPARTMENTS, false);
      return Promise.reject(error);
    }
  },
  async [GET_TEAMS]({ commit }) {
    commit(GETTING_TEAMS, true);
    try {
      const { teams = [] } = await getTeams();
      commit(GET_TEAMS_DONE, teams);
      commit(GETTING_TEAMS, false);
      return Promise.resolve();
    } catch (error) {
      commit(GET_TEAMS_DONE, []);
      commit(GETTING_TEAMS, false);
      return Promise.reject(error);
    }
  },
  async [GET_USER]({ commit }) {
    commit(GETTING_USER, true);
    try {
      const {
        current_member: {
          department_id: unit,
          enable_pickup_code: enablePickupCode,
          has_line_notify: hasLineNotify,
          member_detail: {
            ext,
            phone,
            name,
            serial,
          } = {},
          ...props
        } = {},
      } = await getUser();
      const user = {
        enablePickupCode,
        ext,
        name,
        phone,
        serial,
        unit,
        hasLineNotify,
        ...props,
      };
      commit(GET_USER_DONE, user);
      commit(GETTING_USER, false);
      return Promise.resolve();
    } catch (error) {
      commit(GET_USER_DONE, {});
      commit(GETTING_USER, false);
      return Promise.reject(error);
    }
  },
  async [RESEND_VERIFY_EMAIL]({ commit }, email) {
    commit(RESENDING_VERIFY_EMAIL, true);
    try {
      await resendVerifyEmail(email);
      commit(RESENDING_VERIFY_EMAIL, false);
      return Promise.resolve();
    } catch (error) {
      commit(RESENDING_VERIFY_EMAIL, false);
      return Promise.reject(error);
    }
  },
  async [SEND_FORGET_PASSWORD_LINK]({ commit }, email) {
    commit(SENDING_FORGET_PASSWORD_LINK, true);
    try {
      await sendForgetPasswordLink(email);
      commit(SENDING_FORGET_PASSWORD_LINK, false);
      return Promise.resolve();
    } catch (error) {
      commit(SENDING_FORGET_PASSWORD_LINK, false);
      return Promise.reject(error);
    }
  },
  async [SET_PASSWORD]({ commit }, data) {
    commit(SETTING_PASSWORD, true);
    try {
      await setPassword(data);
      commit(SETTING_PASSWORD, false);
      return Promise.resolve();
    } catch (error) {
      commit(SETTING_PASSWORD, false);
      return Promise.reject(error);
    }
  },
  async [UPDATE_USER]({ commit }, data = {}) {
    commit(UPDATING_USER, true);
    try {
      await updateUser(data);
      commit(UPDATING_USER, false);
      return Promise.resolve();
    } catch (error) {
      commit(UPDATING_USER, false);
      return Promise.reject(error);
    }
  },
  async [USER_LOGIN]({ commit, dispatch }, form) {
    commit(USER_LOGGING, true);
    try {
      const { team_identification: id, team_name: name, token } = await login(form);
      dispatch(SET_LOGIN_DATUM, { id, name, token });
      commit(USER_LOGGING, false);
      return Promise.resolve({ id, name, token });
    } catch (error) {
      dispatch(SET_LOGIN_DATUM, {});
      commit(USER_LOGGING, false);
      return Promise.reject(error);
    }
  },
  [SET_LOGIN_DATUM]({ commit }, { id = null, name = null, token = null }) {
    if (id) {
      localStorage.setItem('team', id);
    }
    if (name) {
      localStorage.setItem('team_name', name);
    }
    localStorage.setItem('_t', token);
    commit(SET_LOGIN_DATUM_DONE, { id, token });
  },
  [REGISTER_LINE_NOTIFY](ctx, payload) {
    return registerLineNotify(payload);
  },
  [UNREGISTER_LINE_NOTIFY]() {
    return unregisterLineNotify();
  },
};
